var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-btn rb shadow bold",class:_vm.disabled || _vm.loading
      ? _vm.subtitle
        ? 'subtitle-padding disabled'
        : 'disabled'
      : !_vm.loading && _vm.active === _vm.btn
      ? 'active'
      : 'zoom',on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.name)+" "),(_vm.subtitle)?_c('div',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e(),(_vm.loading)?_c('div',{staticClass:"subtitle"},[_vm._v(" Loading data... ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }